import React from 'react'

const APC = () => {
  return (
     
    <div>

      <h2 className="fw-bold font-size-23">Open Access Policy</h2>

      <p>
        All articles published by IJISSS are made immediately and freely available worldwide under 
        an open access license. This means:
      </p>

      <ul>
        <li>
          <b>Unrestricted Access:</b> Everyone has free and unlimited access to the full text of all 
          articles published in IJISSS journals.
        </li>
        <li>
          <b>Reuse and Distribution:</b> Anyone may reuse, distribute, or reproduce published material, 
          provided that appropriate credit is given to the original source through proper citation.
        </li>
        <li>
          <b>Funding and APCs:</b> Open access publication is supported by the authors' institutions or 
          research funding bodies through the payment of a modest Article Processing Charge (APC) for 
          each accepted article.
        </li>
      </ul>

      <h3 className="fw-bold text-blue font-size-21">Permissions</h3>
      <p>
        No special permission is required to reuse any part of an article published by IJISSS, 
        including figures and tables. All articles are published under a 
        <b> Creative Commons Attribution (CC BY) license</b>, which allows for unrestricted use, 
        distribution, and reproduction in any medium, provided the original work is properly cited.
      </p>
      <p>
        Please note that reuse of material does not imply endorsement by either the authors or IJISSS.
      </p>

      <h2 className="fw-bold font-size-23">Advantages of Open Access for Authors</h2>

      <h3 className="fw-bold text-blue font-size-21">1. Enhanced Visibility and Reach</h3>
      <p>
        IJISSS ensures that all open access articles are freely and widely accessible online. 
        This increases their visibility among researchers, practitioners, and the public without 
        any subscription or pay-per-view fees.
      </p>
      <p>
        Open access articles are also more likely to be indexed in major databases and discovered 
        through search engines, enhancing readership and impact.
      </p>

      <h3 className="fw-bold text-blue font-size-21">2. Greater Citation Potential</h3>
      <p>
        Studies have shown that open access publications tend to receive more citations due to their 
        wider availability. The increased exposure boosts the visibility and academic influence of 
        authors’ work.
      </p>

      <h3 className="fw-bold text-blue font-size-21">3. Lower Publishing Costs</h3>
      <p>
        The costs associated with editing and handling are covered through a one-time Article 
        Processing Charge (APC), typically paid by the author’s institution or funding agency. 
        IJISSS’s APC is competitively priced and does not vary by article length, encouraging the 
        submission of comprehensive papers.
      </p>

      <h3 className="fw-bold text-blue font-size-21">4. Faster Time to Publication</h3>
      <p>
        IJISSS open access journals operate on a digital-only model, enabling faster turnaround times 
        from acceptance to publication. Articles are published online promptly, significantly reducing 
        delays compared to traditional print-based or subscription journals.
      </p>

      <h2 className="fw-bold font-size-23">Instructions for Authors</h2>

      <p>
        The International Journal of Interdisciplinary Studies and System Science (IJISSS) welcomes 
        high-quality, original research articles in the fields of economics, applied econometrics, 
        development studies, policy analysis, and related empirical disciplines. Authors must adhere 
        to the following submission and formatting guidelines.
      </p>

      <h3 className="fw-bold text-blue font-size-21">1. Originality and Exclusive Submission Policy</h3>
      <p>
        Manuscripts submitted to IJISSS must be entirely original and should not have been published 
        previously in any form, including journals, edited volumes, working papers, conference 
        proceedings, monographs, or book chapters. Concurrent submission of the same manuscript to 
        another journal or outlet is strictly prohibited.
      </p>

      <p>By submitting to IJISSS, authors confirm that:</p>
      <ul>
        <li>The manuscript has not been published previously.</li>
        <li>It is not currently under consideration elsewhere.</li>
        <li>It will not be submitted elsewhere until an official editorial decision is communicated.</li>
      </ul>

      <p>
        Plagiarism, duplicate publication, or significant content overlap with other works may result 
        in immediate rejection and possible blacklisting.
      </p>

    </div>
  )
}

export default APC
